import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ProjectOverview from "@/components/ProjectOverview";
import Amenities from "@/components/Amenities";
import FloorPlans from "@/components/FloorPlans";
import SpecsLocation from "@/components/SpecsLocation";
import ImageGallery from "@/components/ImageGallery";
import VirtualTourContact from "@/components/VirtualTourContact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { KeyonChatEmbed } from "sales-bot-chat-widget";
import FloatingBar from "./FloatingBar";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#FAF9F6]">
      <Navbar />
      <HeroSection />
      <ProjectOverview />
      <Amenities />
      <FloorPlans />
      <ImageGallery />
      <SpecsLocation />
      <VirtualTourContact />
      <Footer />
     <FloatingBar />
      {/* <KeyonChatEmbed
        project="la-valora"
        apiUrl="https://sa-a483f2562b784eafb52dfda574c98339.ecs.ap-south-1.on.aws/"
        themeColor="#c5a059"
        title="La Valora"
        textColor="#ffffff"
      /> */}
    </div>
  );
}
